import React from 'react';
import PropTypes from 'prop-types';
import { Box, Stack, Typography } from '@mui/joy';
import BillCard from '../BillCard/BillCard';

function RelatedBills({relatedBills}) {
  return (
    <Stack direction={"column"} spacing={4}>
      <Typography level="h2" sx={{ fontWeight: 'bold', color: 'white' }}>
        Related Bills
      </Typography>
      <Box sx={{
        display: 'grid',
        gridTemplateColumns: 'repeat(auto-fill, minmax(280px, 1fr))',
        gap: '24px',
      }}>
        {relatedBills ? relatedBills.map((bill, index) => (
          <BillCard key={index} bill={bill} />
        )) : null}
      </Box>
    </Stack>
  );
};

RelatedBills.propTypes = {
    relatedBills: PropTypes.array.isRequired,
}

export default RelatedBills;
